import Vue from 'vue'
import Vuex from 'vuex'
import reputation from './modules/reputation'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    reputation
  }
})
